import { T } from "@repo/transifex";
import { ApiErrorCodesEnum, isApiError } from "~/api/error";

export const DisplayErrorDescription = ({ error }: { error: unknown }) => {
  if (isApiError(error)) {
    switch (error.body.code) {
      case ApiErrorCodesEnum.CHILD_IN_WRONG_SALESPLACE:
        return (
          <T _str="The scanned QR code or employee card is assigned to another salesplace and can’t be used here. Use a valid one or contact your admin if needed." />
        );
      default:
        return null;
    }
  }
  return null;
};
